import * as z from 'zod';
import { createSelectSchema } from 'drizzle-zod';
import type { QueryResult } from '@iichi/schema-database/types/category';
import * as schema from '@iichi/schema-database';

const categoryI18NSchema = createSelectSchema(schema.categoryI18N);

export const categorySchema = createSelectSchema(schema.category)
  .omit({
    createdAt: true,
    parentCategoryId: true,
    sort: true,
    updatedAt: true,
  })
  .extend({
    description: categoryI18NSchema.shape.description,
    name: categoryI18NSchema.shape.name,
    get parentCategory() {
      return categorySchema.optional();
    },
    shortName: categoryI18NSchema.shape.shortName,
  });

export type Category = z.infer<typeof categorySchema>;
export const serialize = (data: QueryResult): Category => {
  const category = {
    ...data,
    description: data.categoryI18Ns?.[0]?.description ?? '',
    name: data.categoryI18Ns?.[0]?.name ?? '',
    parentCategory: data.parentCategory ? serialize(data.parentCategory) : undefined,
    shortName: data.categoryI18Ns?.[0]?.shortName ?? '',
  };

  return categorySchema.parse(category);
};
